module.exports = {
	'CREATED': 'created',
	'DEFINED': 'defined',
	'RENDERED': 'rendered',
	'ERROR': 'error'
};
